import ApiService from "./ApiService"

const ScanService = {
  scanPages: async function (pageIds) {
    const endpoint = `/scan`
    return await ApiService.post(endpoint, pageIds)
  },
}

export default ScanService